export default {
  company: {
    education: {
      default_education_course: '',
      default_education_degree: ''
    }
  },
  applicantOffers: {
    defaultSorters: 'distance'
  }
}
